import cookie from 'react-cookies';

import { SURVEY_COOKIE } from '@r1-frontend/survey/context/constants';
import { Survey, SurveyName, surveyStructure, SurveyType } from '@r1-frontend/survey/context/surveys';

import { RetrieveSurveyProperties } from './types';

type RetrieveCommonSurveyProperties = Omit<RetrieveSurveyProperties, 'name'>
type RetrieveCommonSurveyReturnType = Pick<Survey, 'survey' | 'button'> | undefined

/**
 * Получение общего опроса
 *
 * @param {Object} options
 * @param {number} options.providerId - идентификатор провайдера
 * @param {string} [options.page=''] - страница размещения опроса
 * @param {boolean} [options.withAuth=false] - признак авторизации
 * @returns {(import('../surveys').SurveyItem | undefined)} возвращает общий опрос (или undefined, если нужный опрос не найден)
 */
export const retrieveCommonSurvey = ({ providerId, page = '', withAuth = false }: RetrieveCommonSurveyProperties): RetrieveCommonSurveyReturnType => {
    const allCompleted: Record<SurveyType, SurveyName | SurveyName[]> = cookie.load(SURVEY_COOKIE) || {};

    if ('common' in allCompleted) {
        return;
    }

    let result: RetrieveCommonSurveyReturnType = undefined;

    if (surveyStructure.common.length) {
        // опрос для конкретного провайдера и/или страницы приоритетнее общих
        const sortedByWeight = surveyStructure.common
            .filter(({ survey }) => !Object.values(allCompleted).includes(survey.name))
            .sort((a, b) => (b.providers.length - a.providers.length) + (b.pages.length - a.pages.length));

        for (const survey of sortedByWeight) {
            // Если у опроса есть записи по провайдерам, но нет вхождения по требуемому,
            // нужно перейти к следующей записи в цикле, т.к. этот опрос нам не подходит.
            if (survey.providers.length && !survey.providers.includes(Number(providerId))) {
                continue;
            }

            // Если у опроса есть записи по исключенным провайдерам и есть вхождение по требуемому,
            // нужно перейти к следующей записи, т.к. этот опрос нам не подходит.
            if (survey.excludedProviders.length && survey.excludedProviders.includes(Number(providerId))) {
                continue;
            }

            if (survey.pages.length && !survey.pages.includes(page)) {
                continue;
            }

            if (survey.withAuth === withAuth) {
                result = {
                    survey: survey.survey,
                    button: survey.button,
                };
                break;
            }
        }
    }

    return result;
};
